import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Images from "../../assets";
import html2pdf from "html2pdf.js";
const MGirthPkl = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  console.log("STATE", state);

  const tableData = Array(200).fill({
    length: "23",
    girth: "2",
    cbm: "23.23",
  });

  // Define the chunkData function
  const chunkData = (data, chunkSize) => {
    const result = [];
    for (let i = 0; i < data.length; i += chunkSize) {
      result.push(data.slice(i, i + chunkSize));
    }
    return result;
  };

  const chunkedData = useMemo(() => {
    return chunkData((state && state?.newTeakRounds) || [], 50);
  }, [state]);

  const groupedChunks = [];
  for (let i = 0; i < chunkedData.length; i += 3) {
    groupedChunks.push(chunkedData.slice(i, i + 3));
  }

  // const calculateTotalCBM = (chunk) => {
  //   return chunk
  //     .reduce((total, item) => total + parseFloat(item?.modifyCbm), 0)
  //     .toFixed(3);
  // };

  const calculateTotalCBM = (chunk) => {
    return chunk
      .reduce((total, item) => {
        const valueToUse = state?.mtsNewValue ? item?.cbm : item?.modifyCbm;
        return Number(total) + Number(valueToUse || 0);
      }, 0)
      .toFixed(3);
  };

  const [summaryPageBreak, setSummaryPageBreak] = useState(false);

  useEffect(() => {
    const checkPageBreak = () => {
      const container = document.getElementById("pdf-content");
      const summary = document.getElementById("summary-section");

      if (container && summary) {
        const containerHeight = container.offsetHeight;
        const summaryTop = summary.offsetTop;
        setSummaryPageBreak(summaryTop > containerHeight - 150);
      }
    };

    setTimeout(checkPageBreak, 500);
  }, []);

  const downloadPDF = () => {
    const element = document.getElementById("pdf-content");

    if (!element) {
      console.error("PDF content element not found!");
      return;
    }

    const options = {
      margin: 5,
      // filename: `M-GIRTH PKL - ${state && state?.pkl}.pdf`,
      filename: `${state?.mtsNewValue ? "B-" : "M-GIRTH "}PKL - ${
        state?.pkl
      }.pdf`,

      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: "mm", format: [220, 385], orientation: "portrait" },
    };

    html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        // console.log(`Total pages: ${totalPages}`);

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(0, 0, 0);

          pdf.text(`Page ${i} `, pdf.internal.pageSize.getWidth() / 2, 7, {
            align: "center",
          });
        }
      })
      .save();
  };

  const Header = () => (
    <div
      className="header-section"
      style={{ marginBottom: "0px", position: "relative" }}
    >
      <span style={{ position: "absolute", top: "0px", right: "0px" }}>
        {/* M-{`${state && state?.pkl}`} */}
        {state?.mtsNewValue ? `B-${state?.pkl}` : `M-${state?.pkl}`}
      </span>
      <div className="row p-0 m-0">
        <div className="col-6">
          <div className="row">
            <div className="col-12 pkl-download-from-to-address-head p-0 m-0">
              From
            </div>
          </div>
          <div className="row p-0 m-0">
            <div className="col-1"></div>
            <div className="col-11">
              <h6 className="pkl-download-heading">BEST TIMBERS</h6>
              <p className="pkl-download-from-address">
                New.NO.515, Old.No. 274,
              </p>
              <p className="pkl-download-from-address">Sydenhams Road,</p>
              <p className="pkl-download-from-address">
                Nehru Timber Market, Choolai
              </p>
              <p className="pkl-download-from-address">Chennai - 600112</p>
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="row">
            <div
              className="col-8 pkl-download-from-address text-end p-0 m-0"
              style={{ fontStyle: "normal" }}
            >
              <b>DATE : {state && state?.date}</b>
            </div>
          </div>
          <div className="row p-0 m-0">
            <div className="col-2 pkl-download-from-to-address-head">To</div>

            <div className="col-10 px-4">
              <p className="pkl-download-address py-1">
                {(state && state?.fromName?.toUpperCase()) || ""}
              </p>
              <p className="pkl-download-address py-1">
                {`${(state && state?.fromMobileNumber) || ""}${
                  (state && state?.fromStreet?.toUpperCase()) || ""
                }`}
                ,
              </p>
              <p className="pkl-download-address py-1">
                {`${(state && state?.fromLandmark?.toUpperCase()) || ""}, ${
                  (state && state?.fromCity?.toUpperCase()) || ""
                }, `}
              </p>
              <p className="pkl-download-address py-1">
                {`${(state && state?.fromDistrict?.toUpperCase()) || ""}-${
                  (state && state?.fromPincode) || ""
                } `}
              </p>
              <p className="pkl-download-address py-1">
                GST NO : {(state && state?.gstNumber) || ""}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row p-0 m-0">
        <div className="col-4 p-0 mt-1 mb-0">
          <i style={{ fontSize: "15" }}>Item : </i>
          <span
            style={{
              fontWeight: "bold",
              fontStyle: "normal",
              fontSize: "17px",
            }}
            className="pkl-download-from-address m-0"
          >
            TEAK ROUND LOGS
          </span>
        </div>
        <div className="col-4 p-0 mt-1 mb-0 text-center">
          <h6
            style={{
              fontWeight: "bold",
              fontStyle: "normal",
              fontSize: "17px",
            }}
            className="pkl-download-from-address"
          >
            PKL-{state && state?.pkl}
          </h6>
        </div>
        <div className="col-4 p-0 mt-1 mb-0">
          <i style={{ fontSize: "15px" }}>Lorry No : </i>
          <span
            style={{
              fontWeight: "bold",
              fontStyle: "normal",
              fontSize: "17px",
            }}
            className="pkl-download-from-address"
          >
            {state && state?.lorry}
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <button
        onClick={downloadPDF}
        style={{ position: "absolute", right: "10px", top: "10px" }}
        className="btn btn-success"
      >
        Download PDF
      </button>
      <div
        style={{
          width: "45px",
          height: "45px",
          cursor: "pointer",
          position: "absolute",
          top: "8px",
          left: "40px",
        }}
        onClick={() => {
          navigate(-1);
        }}
      >
        <img src={Images?.backIcon} style={{ width: "100%", height: "100%" }} />
      </div>
      <div
        className="container px-5"
        id="pdf-content"
        style={{ overflow: "auto" }}
      >
        {groupedChunks &&
          groupedChunks?.map((tableGroup, groupIndex) => (
            <div
              key={groupIndex}
              style={{ pageBreakBefore: groupIndex > 0 ? "always" : "auto" }}
            >
              {/* Header for each page */}
              <Header />

              {/* Tables displaying the data */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                {tableGroup &&
                  tableGroup?.map((chunk, tableIndex) => {
                    const startIndex = (groupIndex * 3 + tableIndex) * 50 + 1;

                    const totalTableCBM = calculateTotalCBM(chunk);

                    return (
                      <div
                        key={tableIndex}
                        style={{
                          width: "32%",
                          marginBottom: "10px",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            border: "1px solid black",
                          }}
                        >
                          <thead>
                            <tr>
                              <th className="pkl-download-table-head">S.NO</th>
                              <th className="pkl-download-table-head">
                                LENGTH
                              </th>
                              <th className="pkl-download-table-head">GIRTH</th>
                              <th className="pkl-download-table-head">CBM</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chunk?.map((data, index) => {
                              const continuousIndex = startIndex + index;
                              return (
                                <tr key={index}>
                                  <td className="pkl-download-table-data">
                                    {continuousIndex}
                                  </td>
                                  <td className="pkl-download-table-data">
                                    {data?.length}
                                  </td>
                                  <td className="pkl-download-table-data">
                                    {state?.mtsNewValue
                                      ? data?.girth
                                      : data?.modifyGirth}
                                    {/* {data?.modifyGirth} */}
                                  </td>
                                  <td className="pkl-download-table-data">
                                    {state?.mtsNewValue
                                      ? data?.cbm
                                      : data?.modifyCbm}
                                    {/* {data?.modifyCbm} */}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td
                                colSpan="3"
                                style={{
                                  border: "1px solid black",
                                  padding: "5px",
                                  textAlign: "right",
                                  fontWeight: "bold",
                                }}
                              >
                                <b>Total</b>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "5px",
                                  textAlign: "center",
                                }}
                              >
                                {totalTableCBM}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    );
                  })}
              </div>
            </div>
          ))}

        <div
          id="summary-section"
          style={{ pageBreakBefore: summaryPageBreak ? "always" : "auto" }}
        >
          {summaryPageBreak && <Header />}
          {/* Summary Details */}
          <table>
            <thead>
              <tr>
                <th colSpan="2" style={{ padding: "2px" }}>
                  SUMMARY DETAILS
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  <b>Total CBM</b>
                </td>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  <b>
                    {state && state?.mtsNewValue
                      ? state?.invCBM
                      : state?.modifyTotalCBM}
                  </b>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  <b>Total Nos</b>
                </td>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  {state && state?.totalNos}
                </td>
              </tr>
              {/* {state?.modifyTotalCBM ? (<></>):(<></>)}
              <tr>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  <b>Avg CFT</b>
                </td>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  {state && state?.avgCft}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  <b>Avg Girth</b>
                </td>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  {state && state?.avgGirth}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  <b>Avg Length</b>
                </td>
                <td style={{ padding: "5px", fontSize: "12px" }}>
                  {state && state?.avgLength}
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default MGirthPkl;
